export default "/static/webpack/media/pie.2ff6e1eb.svg";